module.exports = __webpack_public_path__ + "img/transfer13.da2317fa.jpeg";